module.exports = __webpack_public_path__ + "img/phone_step1.152a0591.png";